<template>
  <div>
      <div class="container-fluid">
        <div class="page-header">
          <div class="row">
            <div class="col-sm-6">
              <h3>{{$t("placements")}}</h3>
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>{{$t("management")}}</a></li>
                <li class="breadcrumb-item active">{{$t("placement_management")}}</li>
              </ol>
            </div>
            <div class="col-sm-6">
              <!-- Bookmark Start-->
              <div class="bookmark">
                <ul>
                  <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Tables"><i data-feather="inbox"></i></a></li>
                  <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Chat"><i data-feather="message-square"></i></a></li>
                  <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Icons"><i data-feather="command"></i></a></li>
                  <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Learning"><i data-feather="layers"></i></a></li>
                  <li><a href="javascript:void(0)"><i class="bookmark-search" data-feather="star"></i></a>
                    <form class="form-inline search-form">
                      <div class="form-group form-control-search">
                        <input type="text" :placeholder="$t('search') + '...'">
                      </div>
                    </form>
                  </li>
                </ul>
              </div>
              <!-- Bookmark Ends-->
            </div>
          </div>
        </div>
      </div>
      <!-- Container-fluid starts-->
      <div class="container-fluid">
        <div class="col-md-12 p-0 project-list">
          <div class="card">
            <div class="row">
              <div class="col-md-6 p-0">
                <div class="mb-2">
                  <input class="form-control" type="text" v-model="search" @change="fetchPlacements(true)" :placeholder="$t('search') + '...'">
                </div>
              </div>
              <div class="col-md-6 p-0">                    
                <div class="form-group mb-0 me-0"></div>
                <a class="btn btn-primary-light" @click="$router.push('/create-placement')"> <plus-square-icon class="custom-class"></plus-square-icon>{{$t("CREATE_NEW_PLACEMENT")}}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
                <div class="card">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">{{$t("active")}}</th>
                          <th scope="col">{{$t("icon")}}</th>
                          <th scope="col">{{$t("name")}}</th>
                          <th scope="col">{{$t("type")}}</th>
                          <th scope="col">{{$t("app")}}</th>
                          <th scope="col">{{$t("actions")}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="placement in placements" :key="placement.id">
                          <td><v-switch color="primary" :disabled="requested" v-model="placement.active" @change="togglePlacementActive(placement.id, placement.active)" hide-details></v-switch></td>
                          <td><v-img :src="`/files/images/${placement.previewImage}`" width="50" :aspect-ratio="1"></v-img></td>
                          <td>{{placement.namesMap[$locale]}}</td>
                          <td>{{placement.type}}</td>
                          <td>{{placement.app.name}}</td>
                          <td>
                      <button class="btn btn-light" @click="$router.push('/edit-placement?placementId=' + placement.id)">
                        <edit-icon size="16"></edit-icon></button>
                    </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
          </div>
        </div>
      </div>
      <div style="position:absolute; bottom: 100px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
      <!-- Container-fluid Ends-->
    
  </div>
</template>

<script>

import pagination from './custom/pagination.vue'
import { MapPinIcon,PlusSquareIcon,ClipboardIcon,FileTextIcon,TrashIcon, EditIcon } from 'vue-feather-icons'

export default {

  components: {
    MapPinIcon,
    PlusSquareIcon,
    ClipboardIcon,
    FileTextIcon,
    TrashIcon,
    EditIcon
  },

  data() {
    return {
      page: 1,
      totalPages: 1,
      ElementPerPage: 20,
      sort: null,
      order: true,
      routes: {
        placements: "/api/placement",
        filter: "/api/placement/search/"
      },
      search: "",
      convertedTenants: [],
      tenantFilter: null,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      rules: [(value) => !!value || this.$t("required")],
      placements: [],
      roles: [],
      createTenantPopup: false,
      menu: false,
      createmode: true,
      requested:false,

      // Personal Data
      me: null,
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  mounted() {
    this.fetchPlacements();
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
        if(isIntersecting){
          setTimeout(() => {
            var _this = this;
            if(this.page  < this.totalPages){
                    this.page++;
                    this.$axios
                        .get(this.routes.placements, {
                          params: {
                            search: this.search,
                            sort: this.sort,
                            order: this.order ? "ASC":"DESC",
                            page: this.page -1,
                            size: this.ElementPerPage
                          }
                        })
                        .then(function (response) {
                          if(response.data.content.length >= 1) {
                                response.data.content.forEach(item => _this.placements.push(item));
                                _this.totalPages = response.data.totalPages;
                            }
                        })
                        .catch(this.onError);
                }
            }, 500);
        }
    },
    previousPage() {
      this.page = this.page - 1;
      this.fetchPlacements();
    },
    nextPage() {
      this.page = this.page + 1;
      this.fetchPlacements();
    },
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },
    fetchPlacements(resetPage = false) {
      if(resetPage) this.page = 1;
      var _this = this;
      this.$axios
        .get(this.routes.placements, {
          params: {
            search: _this.search,
            sort: _this.sort,
            order: _this.order ? "ASC":"DESC",
            page: _this.page -1,
            size: _this.ElementPerPage
          }
        })
        .then(function (response) {
          _this.placements = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    updatePage() {
      this.fetchPlacements();
    },

    togglePlacementActive(placementId, active){
      var _this = this;
      this.requested = true;
      this.$axios
        .patch(this.routes.placements + "/" + placementId + "/active/" + active)
        .then(function (response) {
        })
        .catch(this.onError)
        .finally(() => {
          _this.requested = false;
        });
    },

    tableRowClicked(tenantId){
      if(this.$rights.includes('EDIT_CUSTOMERS') || this.$rights.includes('TENANT_INDEPENDENCE')){
        this.$router.push('/edit-tenant?tenantId=' + tenantId)
      }
    },
  }
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>

